import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { IMAGE_CONSTANT, TEXT_CONSTANT } from '../../../constants/app';
import useWindowWidth from '../../../hooks/useWindowWidth';
import LazyImage from '../../../ui-core/Image';
import { getDisplayType } from '../../../utils/helpers';

import './style.css';

const MeetDocJen = props => {
  const isMobileScreen = getDisplayType(useWindowWidth()) === 'mobile';
  const isDesktopScreen = getDisplayType(useWindowWidth()) === 'desktop';
  const isIpadScreen = getDisplayType(useWindowWidth()) === 'ipad';
  const styling =
    isDesktopScreen && props.lowBodyImpact
      ? { padding: '80px 18px' }
      : { undefined };
  return (
    <Row
      className={clsx(
        'back-impact-section',
        isDesktopScreen & 'text-white row-margin-zero',
        isMobileScreen && 'flex-column-reverse',
        isIpadScreen && 'flex-column',
      )}
    >
      <Col
        className={
          props.lowBodyImpact
            ? 'back-impact d-flex justify-content-center align-items-center doc-info'
            : 'd-flex justify-content-center align-items-center doc-info'
        }
        style={props.backColor && { background: props.backColor }}
        xs={12}
        md={isDesktopScreen ? 7 : 12}
      >
        <div className="doc-jen-block" style={styling}>
          <h4 className="font-weight-bold">
            {props.lowBodyImpact
              ? TEXT_CONSTANT.MEET_DOC_JEN_FRABONI
              : TEXT_CONSTANT.MEET_DOC_JENFIT}
          </h4>
          <p className="font-weight-bold">
            {props.lowBodyImpact
              ? TEXT_CONSTANT.DOC_INFO_3
              : TEXT_CONSTANT.DOC_INFO_1}
          </p>
          <p>
            {props.lowBodyImpact
              ? TEXT_CONSTANT.DOC_INFO_4
              : TEXT_CONSTANT.DOC_INFO_2}
          </p>
        </div>
      </Col>
      <Col xs={12} md={isDesktopScreen ? 5 : 12} className="p-0 impact-img">
        <div className="p-relative">
          <LazyImage
            alt="doc jen"
            className="w-100 h-100 doc-jen-image"
            errorSrc={props.imgSrcSet.errorSrc}
            placeholderSrc={props.imgSrcSet.placeholderSrc}
            src={props.imgSrcSet.src}
          />
          {props.isBackgroundDiv && <div className="doc-jen-bg"></div>}
        </div>
      </Col>
    </Row>
  );
};

MeetDocJen.propTypes = {
  backColor: PropTypes.string,
  lowBodyImpact: PropTypes.bool,
  imgSrcSet: PropTypes.object,
  isBackgroundDiv: PropTypes.bool,
};

MeetDocJen.defaultProps = {
  imgSrcSet: {
    errorSrc: IMAGE_CONSTANT.MeetDocJenFit,
    placeholderSrc: IMAGE_CONSTANT.MeetDocJenFitLow,
    src: IMAGE_CONSTANT.MeetDocJenFitWebp,
    isBackgroundDiv: false,
  },
};

export default MeetDocJen;
